/** 天好 originalData: wxid|phone----token----typeNo----35----openid----unionid----userId */
export function parseTimsOriginalData(decryptedText) {
  const parts = String(decryptedText || '').split('----');
  const head = parts[0] || '';
  let wxid = head;
  let phone = '';
  if (head.includes('|')) {
    const [a, b] = head.split('|', 2);
    wxid = a;
    phone = b || '';
  }
  return {
    wxid,
    phone,
    token: parts[1] || '',
    couponTemplateId: parts[2] || '',
    teaType: parts[3] || '',
    openid: parts[4] || '',
    unionid: parts[5] || '',
    userId: parts[6] || '',
  };
}

export function formatDistance(m) {
  const n = Number(m);
  if (!n && n !== 0) return '';
  if (n < 1000) return `${Math.round(n)}m`;
  return `${(n / 1000).toFixed(1)}km`;
}

export function fenToYuan(fen) {
  const n = Number(fen);
  if (Number.isNaN(n)) return '0';
  return (n / 100).toFixed(n % 100 === 0 ? 0 : 2);
}
